import { Navigate } from 'react-router-dom';
import { LoadingSpinner } from '../../components/ui/LoadingSpinner';
import { usePermissions } from '../../contexts/PermissionsContext';
import { DashboardPage } from './DashboardPage';
import { ProspectionDashboardPage } from './ProspectionDashboardPage';

export function DashboardRouter() {
  const { isLoading, canAccessModule } = usePermissions();

  if (isLoading) {
    return <LoadingSpinner label="Carregando painel..." />;
  }

  const canExecutive = canAccessModule('dashboard.executive');
  const canProspection = canAccessModule('dashboard.prospection');

  if (canProspection && !canExecutive) {
    return <ProspectionDashboardPage />;
  }

  if (canExecutive) {
    return <DashboardPage />;
  }

  if (canProspection) {
    return <ProspectionDashboardPage />;
  }

  return <Navigate to="/access-denied" replace />;
}
